import React from 'react'
import styled from 'styled-components'
import Outer from '../../../../styles/outer/Outer'
import ServiceBg01 from '../../../../assets/bg/mobile/bg_service_01.png'
import ServiceBg02 from '../../../../assets/bg/mobile/bg_service_02.png'
import ServiceBg03 from '../../../../assets/bg/mobile/bg_service_03.png'
import ServiceBg04 from '../../../../assets/bg/mobile/bg_service_04.png'
import ServiceBg05 from '../../../../assets/bg/mobile/bg_service_05.png'
import ServiceBg06 from '../../../../assets/bg/mobile/bg_service_06.png'

const ServiceMobileComponent = () => {
  return (
    <StyledWrap>
      <img src={ServiceBg01} />
      <img src={ServiceBg02} />
      <img src={ServiceBg03} />
      <img src={ServiceBg04} />
      <img src={ServiceBg05} />
      <img src={ServiceBg06} />
    </StyledWrap>
  )
}

export default ServiceMobileComponent

const StyledWrap = styled.div`
  background-color: #f5f5f5;
`
